import React, { Component } from "react";
import { connect } from "react-redux";
import instance from "../../store/actions/instance";
import { saveSearch } from "../../store/actions/store";
import ProductInList from "../Menu/ScrollView/ProductInList";
import CircularProgress from "@material-ui/core/CircularProgress";
import ScrollContainer from "react-indiana-drag-scroll";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import LoadingScroll from "../ScrollViewLoading/Menu";

class ProductRecommendations extends Component {
  state = {
    recommendedProducts: [],
    loading: true,
    is_scrollAble: true,
  };
  container = React.createRef();
  fetchRecommendedProducts = async () => {
    const { settings, branch } = this.props;
    this.setState({ loading: true });
    try {
      const res = await instance.post("/get_product_recommendations/", {
        ids: this.props.current_product?.id
          ? [this.props.current_product?.id]
          : [
              ...this.props.cart.cart.map((i) => i.id),
              ...this.props.cart.promo_items.map((i) => i.id),
            ],

        exclude: this.props.cartBased
          ? [
              ...this.props.cart.cart.map((i) => i.id),
              ...this.props.cart.promo_items.map((i) => i.id),
            ]
          : [],
      });
      if (res.data.success && res.data.data?.length) {
        let res2;
        if (
          settings.is_branch_based_ordering &&
          (branch.branch || branch.bdc)
        ) {
          res2 = await instance.post("/search_products_branch_based/000000/", {
            type: branch.isPickup ? "pickup" : "delivery",
            branch_id: branch.branch,
            bdc_id: !branch.isPickup ? branch.bdc : branch.branch,
            used_components: this.props.usedComponents,
            country_code: this.props.currency.selected,
            specific_product_ids: res.data.data?.filter(
              (id) =>
                id !== this.props.current_product?.id &&
                ![
                  ...this.props.cart.cart.map((i) => i.id),
                  ...this.props.cart.promo_items.map((i) => i.id),
                ].includes(id)
            ),
            fromRecommendations: true,
            channel: this.props.channel,
          });
        } else {
          res2 = await instance.post("/search_products/000000/", {
            used_components: this.props.usedComponents,
            country_code: this.props.currency.selected,
            specific_product_ids: res.data.data?.filter(
              (id) =>
                id !== this.props.current_product?.id &&
                ![
                  ...this.props.cart.cart.map((i) => i.id),
                  ...this.props.cart.promo_items.map((i) => i.id),
                ].includes(id)
            ),
            fromRecommendations: true,
            channel: this.props.channel,
          });
        }
        if (res2.data.products) {
          this.props.saveSearch(res2.data.products);

          this.setState({
            recommendedProducts: res2.data.products,
          });
        }
      }
    } catch (e) {
      console.error("Couldn't fetch product recommendations", e);
    }
    this.setState({ loading: false });
  };
  componentDidUpdate = (prevProps, prevState) => {
    const { settings } = this.props;

    if (
      (prevProps.secondLoading === true &&
        this.props.secondLoading === false) ||
      this.props.current_product?.id !== prevProps.current_product?.id
    )
      this.fetchRecommendedProducts();

    if (
      prevState.loading !== this.state.loading &&
      prevState.loading &&
      this.state.recommendedProducts?.length
    ) {
      if (this.container.current) {
        let CheckScrollAble =
          this.container.current.container.current.scrollWidth >
          this.container.current.container.current.clientWidth;
        if (CheckScrollAble !== this.state.is_scrollAble) {
          this.setState({
            is_scrollAble: CheckScrollAble,
          });
        }
      }
    }
  };

  componentDidMount = () => {
    if (!this.props.secondLoading) this.fetchRecommendedProducts();
  };

  renderTitle = () => {
    const { language } = this.props;
    if (this.props.cartBased)
      return language === "arabic" ? "قد يعجبك ايضا" : "You might also like";
    return language === "english"
      ? "Frequently purchased with"
      : "عادة يشترى مع";
  };
  render() {
    const { settings, language } = this.props;
    const { recommendedProducts, loading } = this.state;
    if (!loading && !recommendedProducts?.length) return <></>;

    return (
      <div style={{ marginTop: 30 }}>
        {!loading ? (
          <>
            <p
              className="bold mb-2 box-title"
              style={{
                padding: "0px 10px",
                textAlign: language === "arabic" ? "right" : "left",
              }}
            >
              {this.renderTitle()}
            </p>

            <div
              className={`d-flex  align-items-center w-100 border ${
                language === "arabic" ? "flex-row-reverse" : ""
              }`}
              style={{
                background: "white",
                padding: "20px 5px",
              }}
            >
              {this.state.is_scrollAble && (
                <ArrowBackIosIcon
                  className="pointer mx-1   "
                  style={{
                    marginBottom: "55px",
                    transform: language === "arabic" && "rotateY(180deg)",
                  }}
                  onClick={() =>
                    (this.container.current.container.current.scrollLeft +=
                      -100)
                  }
                />
              )}
              <ScrollContainer
                vertical={false}
                ref={this.container}
                style={{
                  width: "100%",

                  overflowY: "hidden",
                  direction: language === "english" ? "ltr" : "rtl",
                }}
                className={`d-flex  ${
                  !this.state.is_scrollAble ? "justify-content-center" : ""
                } `}
              >
                {recommendedProducts.map((p, index) => (
                  <ProductInList
                    product={p}
                    is_last={index + 1 === recommendedProducts ? true : false}
                    is_first={index === 0 ? true : false}
                    key={"gird_category_item " + p.name + " " + p.id}
                    category_id={p.category_id}
                    fromRecommendations
                    fromCart={this.props.fromCart}
                    fromCheckout={this.props.fromCheckout}
                  />
                ))}
              </ScrollContainer>
              {this.state.is_scrollAble && (
                <ArrowForwardIosIcon
                  style={{
                    marginBottom: "55px",
                    transform: language === "arabic" && "rotateY(180deg)",
                  }}
                  className="mx-1 pointer"
                  onClick={() =>
                    (this.container.current.container.current.scrollLeft += 100)
                  }
                />
              )}
            </div>
          </>
        ) : (
          <CircularProgress
            style={{ width: 30, height: 30, color: this.props.themeColor }}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    settings: state.store.store.settings,
    usedComponents: state.store.used_components,
    currency: state.currency,
    secondLoading: state.store.secondLoading,
    cart: state.cart,
    branch: state.branch,
    themeColor: state.store.store.settings.dark || "#0099cc",
    channel: state.promise.src,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveSearch: (categories) => dispatch(saveSearch(categories)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProductRecommendations);
